module.exports = __webpack_public_path__ + "media/brand/Perfil-auto-tarjetas-21e30366.png";